module.exports = "/images/arrow-back.svg?59dd42ad6a13126b0336f963b31ee7a5";